<template>
  <v-app>
    <div id="app">
      <div v-if="nav_switch == 1">
        <div id="reception-sys">
          <router-link to="/register">仮登録</router-link> |
          <router-link to="/sent_confirmation_mail">仮登録メール送信完了</router-link> |
          <router-link to="/success_register">仮登録完了</router-link> |
          <router-link to="/login">ログイン</router-link> |
          <router-link to="/system_error">システムエラー</router-link> |
          <router-link to="/update">本登録</router-link> |
          <router-link to="/update_confirmation">本登録内容確認</router-link> |
          <router-link to="/mypage">マイページ</router-link>
        </div>
        <div id="reservation-sys">
          <router-link to="/studio_search">空き検索</router-link> |
          <router-link to="/studio_detail">予約詳細</router-link> |
          <router-link to="/studio_confirm">内容確認</router-link> |
          <router-link to="/studio_complete">予約完了</router-link>
        </div>
      </div>
      <router-view />
    </div>
  </v-app>
</template>

<style lang="stylus">
@import './common/*'
#reception-sys
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
</style>

<script lang="ts">
import {Switch} from '@/common/core/common';

export default {
  data() {
    return {
      nav_switch: Switch.DEBUG_SWITCH,
    }
  },
  methods: {
    setMeta(to: any): void {
      if (to.meta.title) {
        document.title = to.meta.title;
      }
      if (to.meta.desc) {
        document.querySelector("meta[name='description']")!.setAttribute('content', to.meta.desc);
      }
    },
  },
  watch: {
    $route(to: any) {
      (this as any).setMeta(to);
    }
  },
  name: 'App',
};
</script>
